module.exports = __webpack_public_path__ + "app/principal/invitation-details-3muGZRmA.html";